import React, { useState } from 'react'
import Flex from 'typescript-styled-flex'
import { Divider, IconButton, useMediaQuery, useTheme } from '@material-ui/core'
import { FiTrash } from 'react-icons/fi'
import { Trans } from 'react-i18next'
import { connect } from 'react-redux'
import Price from '../../../components/Price/Price'
import { IStore } from '../../../reducers'
import { getUserCurrency } from '../../../reducers/userObject/selectors/object'
import { is } from '../../../components/MediaQuery'
import { withSize } from '../../../hooks/useSize'
import { theme } from '../../../theme'
import { PriceInputWithCurrency } from './Components'
import { PopoveredIcon2 } from '../../../components/PopoveredIcon/PopoveredIcon'
import UpgradePremiumBlockScreenModal from '../../UpgradePremiumBlockScreenModal/UpgradePremiumBlockScreenModal'

const renderSubFields = (
  isDesktop,
  formName,
  currency,
  member,
  index,
  fields,
  size,
  allowReservationEdit = true,
  handlePopoverOpen: any
) => {
  const service = fields.get(index)

  function remove() {
    fields.remove(index)
  }

  return (
    <React.Fragment key={`services-${index}`}>
      <Flex
        row={true}
        style={{ marginBottom: `${8 * size}px`, width: '100%' }}
        justifyBetween={true}
        alignCenter={true}
      >
        <Flex column={true} style={{ width: '100%' }}>
          <div
            style={{
              color: theme.colors.form.label,
              fontSize: `${14 * size}px`,
              fontWeight: 500,
              margin: `${9 * size}px 0px`,
              paddingRight: `${28 * size}px`,
              width: '100%',
              wordBreak: 'break-all',
              display: 'flex',
              alignItems:'center',
              gap: '8px'
            }}
          >
            {service.name}
            {!allowReservationEdit && <PopoveredIcon2 />}
          </div>

          <Flex row={true} alignCenter={true} style={{ width: '100%' }}>
            <PriceInputWithCurrency
              zeroOnUndefinied={true}
              size={size}
              disabled={!allowReservationEdit}
              isSmallReservation={true}
              name={`${member}.price`}
              width={'100%'}
            />

              <IconButton
                onClick={!allowReservationEdit ? handlePopoverOpen : remove}
                style={{
                  marginRight: `${-11 * size}px`,
                  padding: `${11 * size}px`,
                }}
              >
                <FiTrash
                  color={allowReservationEdit ? 'red' : 'gray'}
                  size={15 * size}
                />
              </IconButton>
          </Flex>
        </Flex>
      </Flex>
    </React.Fragment>
  )
}

function Services({ fields, currency, formName, allowReservationEdit, size }) {
  const isDesktop = is.desktop()
  const theme2 = useTheme()
  const isMobile = useMediaQuery(theme2.breakpoints.down('sm'))
  const [isModalOpened, setIsModalOpened] = useState(false)
  const [popoverAnchor, setPopoverAnchor] = useState(null)

  const handlePopoverOpen = event => {
    if (isMobile) {
      setIsModalOpened(true)
    } else {
      event.preventDefault()
      event.stopPropagation()
      setPopoverAnchor(event.currentTarget)
    }
  }

  const handlePopoverClose = event => {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    setPopoverAnchor(null)
  }

  const Fields = fields.map((member, index, fields) =>
    renderSubFields(
      isDesktop,
      formName,
      currency,
      member,
      index,
      fields,
      size,
      allowReservationEdit,
      handlePopoverOpen
    ),
  )

  let summary = 0
  if (Fields.length > 0) {
    fields.forEach((_, index) => {
      if (fields.get(index).price) {
        summary = summary + Number(fields.get(index).price)
      }
    })
  }

  return (
    <Flex full={true} column={true}>
      {Fields}
      {Fields.length > 0 && (
        <>
          <Divider style={{ marginTop: `${2 * size}px` }} />
          <Flex
            full={true}
            justifyBetween={true}
            style={{
              marginRight: `${28 * size}px`,
              marginTop: `${10 * size}px`,
            }}
          >
            <div
              style={{
                color: '#696a6d',
                fontSize: `${13 * size}px`,
              }}
            >
              <Trans i18nKey={'finances_sum'} />
            </div>
            <div
              style={{
                color: '#696a6d',
                fontSize: `${13 * size}px`,
                marginRight: `${28 * size}px`,
              }}
            >
              <Price
                allowReservationEdit={allowReservationEdit}
                value={summary}
                currency={currency}
              />
            </div>
          </Flex>
        </>
      )}
      <PopoveredIcon2
        withIcon={false}
        anchorEl={popoverAnchor}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      />
      {isMobile && <UpgradePremiumBlockScreenModal
        open={isModalOpened}
        close={() => setIsModalOpened(false)}
      />}
    </Flex>
  )
}

export default connect((state: IStore) => ({
  currency: getUserCurrency(state),
}))(withSize(Services))
